import { Directive, EventEmitter, Input, OnInit, Output, } from '@angular/core';
import { SortColumn,SortDirection,SortEvent } from '../../models/common.model';


@Directive({
	selector: 'th[sortable]',
	host: {
		'[class.asc]': 'direction === "asc"',
		'[class.desc]': 'direction === "desc"',
		'(click)': 'rotate()',
	},
})
export class NgbdSortableHeader {
	@Input() sortable: SortColumn = '';
	@Input() direction: SortDirection = '';
	@Output() sort = new EventEmitter<SortEvent>();
	rotateDir: { [key: string]: SortDirection } = { asc: 'desc', desc: '', '': 'asc' };

	rotate() {
		this.direction = this.rotateDir[this.direction];
		this.sort.emit({ column: this.sortable, direction: this.direction });
	}
}